import {
  ChangeDetectorRef,
  Component,
  inject,
  ViewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatNativeDateModule } from '@angular/material/core';
import { GamificationCardsService } from '../services/gamification-cards.service';
import { ErrorNotficationComponent } from '../error-notfication/error-notfication.component';
import {
  MatDialog,
  MatDialogModule,
} from '@angular/material/dialog';
import {
  IDropdownSettings,
  NgMultiSelectDropDownModule,
} from 'ng-multiselect-dropdown';
import { AdminService } from '../services/admin.service';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { FormsModule } from '@angular/forms';
import { PromtUserService } from '../services/prompt-user.service';
import { DrawerService } from '../services/shared/Drawer.service';
import { MultiSelectDropdownComponent } from './dialogs/multi-select-dropdown/multi-select-dropdown.component';
import { DashboardService } from '../services/shared/dashboard.service';
import { MostUsedPromptsDialogComponent } from './dialogs/most-used-prompts-dialog/most-used-prompts-dialog.component';
import { TopMostCategoriesComponent } from './dialogs/top-most-categories/top-most-categories.component';
import { MostTrendingPromptsDialogComponent } from './dialogs/most-trending-prompts-dialog/most-trending-prompts-dialog.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { CuratorListDialogComponent } from './dialogs/curator-list-dialog/curator-list-dialog.component';
import {DateRangePickerComponent} from '../components/common/components/date-range-picker/date-range-picker.component';
import { NgbCalendar, NgbDate, NgbDatepickerModule } from '@ng-bootstrap/ng-bootstrap';
import { PowerUsersDialogComponent } from './dialogs/power-users-dialog/power-users-dialog.component';
import { LoaderComponent } from '../components/common/components/loader/loader.component';
@Component({
  selector: 'app-gamification-board',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatTableModule,
    MatSelectModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatIconModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgMultiSelectDropDownModule,
    MatButtonModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    CommonModule,
    MatDialogModule,
    MatSortModule,
    MatSelectModule,
    NgMultiSelectDropDownModule,
    MatTableModule,
    MultiSelectDropdownComponent,
    MatTooltipModule,
    NgbDatepickerModule,
    LoaderComponent
  ],
  templateUrl: './gamification-board.component.html',
  styleUrl: './gamification-board.component.scss',
})
export class GamificationBoardComponent {
  value='1/Jan/2025 – 22/May/2025';
  dropdownSettings: IDropdownSettings = {};
  @ViewChild('dropdownRef') dropdownRef: any;
  roleDropdownList: any = [];
  allPrompt: any;
  selectedCardIndex: number | null = null;
  selectedCat: any = [];
  onMyApprovalClick: boolean = false;
  isfavourite: boolean = false;
  isCategory: boolean = true;
  user_role: any;
  promptCount: any;
  status: any = [];
  sub_category_id: any = [];
  limit = 50;
  page_number = 1;
  scrollHeight = 2000;
  dropDownCategories: any = [];
   private readonly STORAGE_KEY = 'dateRangePickerState';
  public tempSelectedItems: any[]=[];

  mostUsedPromptsData: any;
  mostTrendingPromptsData: any;
  curatorListData: any;
  powerUsersData: any;
  topCategory:any;
  topUserList:any=[];
  topCreatorList:any=[];

  categoryDropdownSettings: IDropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'name',
    selectAllText: 'All Category',
    unSelectAllText: 'All Category',
    itemsShowLimit: 1,
    enableCheckAll: false,
  };


    currentIndex=0;
    current_creator_Index=0;
    Top_creator=this.topCreatorList[this.current_creator_Index];
    Top_user=this.topUserList[this.currentIndex];

    get currentItem(): string {
      return this.topUserList[this.currentIndex];
    }
    
    get totalItems(): number {
      return this.topUserList.length;
    }

    get current_creator_Item(): string {
      return this.topCreatorList[this.current_creator_Index];
    }
    
    get total_creator_Items(): number {
      return this.topCreatorList.length;
    }

    next(type:string) {
 

      if(type == 'user'){
      if (this.currentIndex < this.topUserList.length - 1) {
        this.currentIndex++;
        this.Top_user=this.topUserList[this.currentIndex];
      }
      }
      else if(type == 'creator'){
    
      if (this.current_creator_Index < this.topCreatorList.length - 1) {
        this.current_creator_Index++;
        this.Top_creator=this.topCreatorList[this.current_creator_Index];
      }
    }

    }
  
    previous(type:string) {
    

    if(type == 'user'){  
      if (this.currentIndex > 0) {
        this.currentIndex--;
        this.Top_user=this.topUserList[this.currentIndex];
      }
    }else if(type == 'creator'){
      if (this.current_creator_Index > 0) {
        this.current_creator_Index--;
        this.Top_creator=this.topCreatorList[this.current_creator_Index];
      }
    }
    }
  displayedColumns: string[] = [
    'prompt_name',
    'usage',
    'consumers',
    'average_rating',
  ];
  displayedColumnsCategories: string[] = [
    'category','prompts','users','usage', 'average_time_saved', 'average_rating'
  ];
  displayedCuratorListColumns: string[] = ['curator_name', 'category', 'reviewed', 'approved', 'rejected'];
  displayedPowerUsersColumns: string[] = ['username', 'role', 'prompt_activity', 'points'];
  dataSource = new MatTableDataSource<any>();
  trendingPromptsDataSource = new MatTableDataSource<any>();
  curatorListDataSource = new MatTableDataSource<any>();
  powerUsersDataSource = new MatTableDataSource<any>();
  topCategories=  new MatTableDataSource<any>();
  searchtext: string = '';
  userid: any;
  modal: any;
  allcategory: any = [];
  createdbyarray: any;
  onMyFavouriteClick: boolean = false;
  onMyPromptsClick: boolean = false;
  totalPages = 0;
  clearfilter: boolean = false;
  categoriesList: any;
  isLoading: boolean = false;

  // for the get api filters call
  role: any;
  category: any;

  sort_by: string = '';
  order: string = '';
  search_text: string = '';
  category_id: any = [];
  calendar=inject(NgbCalendar);
  startDate: any;
  endDate: any;

  statCards = [
    { title: 'Total Prompts', value: 0, tooltip: 'Total number of prompts published, including both active and inactive prompts' },
    { title: 'Active Prompts', value: 0, tooltip: 'Prompts that have been used at least once in the last 90 days' },
    { title: 'In-active Prompts', value: 0, tooltip: 'Prompts that haven’t been used in the last 90 days' },
    { title: 'Total Categories', value: '0' },
  ];
  rightCards = [
    { title: 'Total Usage', value: 0, tooltip: 'Total number of prompt runs (usage)' },
    { title: 'Time Saving Est.', value: 0, tooltip: 'Total time-saving estimates for prompts' },
    { title: 'Users', value: 0, tooltip: 'Total number of active users' },
    { title: 'Avg. Quality Rating', value: '0', tooltip: 'The average star rating given by users to all active and inactive prompts' },
  ];
  constructor(
    private readonly gamificationService: GamificationCardsService,
    private readonly adminService: AdminService,
    private readonly dialog: MatDialog,
    private readonly promptUserService: PromtUserService,
    private readonly cd: ChangeDetectorRef,
    private readonly drawerService: DrawerService,
    private readonly dashboardService: DashboardService
  ) {}
  ngOnInit() {
    this.userid = this.dashboardService.user_id;
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 1,
      allowSearchFilter: false,
    };
    const savedState = localStorage.getItem(this.STORAGE_KEY);
    if(savedState){
       const state = JSON.parse(savedState);
       if(state.value){
        this.value=state.value;
       }
    }else{
      this.value = this.getFormattedRange(this.calendar.getPrev( this.calendar.getToday(), 'd', 30),this.calendar.getToday());
    }
      const [startStr, endStr] = this.value.split(" - ");
      this.startDate = this.formatDate(startStr);
      this.endDate = this.formatDate(endStr);
    
    this.getAllCategories();
    this.getCategory();
    this.getShanshotDetails(this.category_id, this.sub_category_id);
    this.callMultipleApi();
    this.selectedCat = [...this.dropDownCategories];
    
  }

  public getFormattedRange(fromDate: NgbDate, toDate: NgbDate): string {
      const months = [
        '',
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'June',
        'July',
        'Aug',
        'Sept',
        'Oct',
        'Nov',
        'Dec',
      ];
  
      const format = (date: NgbDate): string =>
        `${date.day}/${months[date.month]}/${date.year}`;
  
      return `${format(fromDate)} - ${format(toDate)}`;
    }

  // getTotalUsersCount() {
  //   const url = this.apiURL + 'gamification/get_total_users_count';
  //   return this.http.get<any>(url);
  // }

  // getAverageRating() {
  //   const url = this.apiURL + 'gamification/get_average_rating';
  //   return this.http.get<any>(url);
  // }

  

  firstGridStats = this.statCards.slice(0, 4);
  secondGridStats = this.statCards.slice(4, 8);

  getShanshotDetails(categories: number[], subcategories: number[]) {
    this.gamificationService
      .getPromptCount(categories, subcategories)
      .subscribe((res) => {
        this.statCards[0].value = res?.data.total_prompts;
        this.statCards[1].value = res?.data.active_prompts;
        this.statCards[2].value = res?.data.inactive_prompts;
      });

    this.gamificationService
      .getTotalCategoriesCount(categories, subcategories)
      .subscribe((res) => {
        let total_categories=res?.data.total_categories;
        if(categories?.length > 0 && total_categories > 0 &&  categories?.length == total_categories){
          this.statCards[3].value = res?.data.total_categories;
          this.isCategory=true;
        }else if(categories?.length == 0 && subcategories?.length == 0){
          this.statCards[3].value = res?.data.total_categories;
          this.isCategory=true;
        }
        else{
          let temp_cat= this.allcategory.filter((data:any)=>
            {
              return data?.subcategories.find((val:any)=> subcategories?.includes(val.id));
            });
            temp_cat= temp_cat.map((val:any)=>val.id);
            const uniqueCat = [...new Set([...categories, ...temp_cat])];
          this.statCards[3].value =uniqueCat?.length;
          this.isCategory=false;
        }
      });

    this.gamificationService
      .getTotalUsage(categories, subcategories)
      .subscribe((res) => {
        this.rightCards[0].value = res?.data.total_usage;
      });
    this.gamificationService
      .getAverageTimeSaved(categories, subcategories)
      .subscribe((res) => {
        this.rightCards[1].value = this.formatTimeString(res?.data.average_time_saved);
      });

    this.gamificationService
      .getTotalUsersCount(categories, subcategories)
      .subscribe((res) => {
        this.rightCards[2].value = res?.data.total_users;
      });
    this.gamificationService
      .getAverageRating(categories, subcategories)
      .subscribe((res) => {
        this.rightCards[3].value = res?.data.average_rating;
      });
  }

  public formatTimeString(timeStr:string) {
    const [hoursStr, minsStr] = timeStr.split(':');
    const hours = parseInt(hoursStr, 10) || 0; // Ensure 0 if NaN
    const mins = parseInt(minsStr, 10) || 0;   // Ensure 0 if NaN

    return `${hours} hr ${mins} min`; // Always includes both units
  }
  getAllCategories() {
    this.isLoading = true;
    this.adminService.getAllCategories().subscribe({
      next: (resp:any) => {
        this.isLoading = false;
        const categoryIds: any[] = [];
        const subcategoryIds: any[] = [];
        resp.data?.filter((obj: any) => {
          categoryIds.push(obj.id)
          obj.sub_categories.filter((item: any) => item.id).forEach((subCatObj:any) => {
            subcategoryIds.push(subCatObj.id);
          });
        });
        
        this.category_id = categoryIds;
        this.sub_category_id = subcategoryIds;
        this.categoriesList = resp?.data.filter((item: any) => item.is_active);
      
      },error: (error:any) => {
        this.isLoading = false;
        this.openSnackbar(
          error?.error?.message,
          'An error occurred',
          'error-snackbar'
        );
      }
  });
  }

  getallprompmtByfilter(
    search_text: string,
    userid: number,
    modal: [],
    category_id: [],
    sub_category_id: [],
    createdbyarray: [],
    onMyFavouriteClick: boolean,
    onMyPromptsClick: boolean,
    onMyApprovalClick: boolean,
    user_role: string,
    status: [],
    sort_by: string
  ) {
    this.isLoading = true;
    this.selectedCardIndex = null;
    this.drawerService.closeDrawer();
    this.page_number = 1;
    this.scrollHeight = 0;


    this.promptUserService
      .getAllPrompts(
        search_text,
        userid,
        modal,
        category_id,
        sub_category_id,
        createdbyarray,
        onMyFavouriteClick,
        onMyPromptsClick,
        onMyApprovalClick,
        user_role,
        status,
        sort_by,
        this.page_number,
        this.limit
      )
      .subscribe({
        next: (response:any) => {
          this.allPrompt = response.data.data;
    
         
          this.totalPages = Math.ceil(response.data.total_count / this.limit);

          this.promptCount = response.data.total_count;
          //this.promptlist = response.data
          this.cd.markForCheck();
          this.isLoading = false;
        },error: (error:any) => {
          console.log(error);
          this.isLoading = false;
        }
    });
  }
  getCategory() {
    this.isLoading = true;
    this.promptUserService
      .getAllCate(
        this.searchtext,
        this.userid,
        this.modal,
        [],
        [],
        this.createdbyarray,
        this.onMyFavouriteClick,
        this.onMyPromptsClick,
        this.user_role,
        []
      )
      .subscribe({
        next: (response:any) => {
          this.isLoading = false;
         
          this.allcategory = response.data;
          let tempCategory: any = [];
          response.data.forEach((element: any, index: any) => {
            if (element.subcategories.length > 0) {
              tempCategory.push(element);
              element.subcategories = element.subcategories.map((item: any) => {
                return { ...item, isNested: true, subcategories: [] };
              });
              tempCategory.push(...element.subcategories);
            } else {
              tempCategory.push(element);
            }
          });

          
          let all_cate = {
            created_datetime: '2025-02-07T15:48:48.656552',
            description: '',
            id: 0,
            name: 'All categories',
            parent_category_id: null,
            prompt_count: 4,
            subcategories: [],
          };
          this.dropDownCategories = [
            all_cate,
            ...JSON.parse(JSON.stringify(tempCategory)),
          ];
          
          this.selectedCat = [...this.dropDownCategories];
        
          tempCategory = [];
          this.cd.markForCheck();
        },error: (error:any) => {
          console.log(error);
          this.isLoading = false;
        }
  });
  }

  getAllCategory(
    search_text: string,
    userid: number,
    modal: [],
    category_id: [],
    sub_category_id: [],
    createdbyarray: [],
    onMyFavouriteClick: boolean,
    onMyPromptsClick: boolean,
    user_role: string,
    status: []
  ) {
    this.isLoading = true;
    this.promptUserService
      .getAllCate(
        search_text,
        userid,
        modal,
        category_id,
        sub_category_id,
        createdbyarray,
        onMyFavouriteClick,
        onMyPromptsClick,
        user_role,
        status
      )
      .subscribe({
        next: (response:any) => {
          this.isLoading = false;
          this.allcategory = response.data;

          this.cd.markForCheck();
        },error: (error:any) => {
          console.log(error);
          this.isLoading = false;
        }
  });
  }

  public onItemSelect(item: any, a: any) {
    if (item.item_id === 0) {
      // 'All Categories' selected - select all items
      this.selectedCat = [...this.dropDownCategories];
    }
  }

  public onItemDeSelect(item: any, b: any) {
    if (item.item_id === 0) {
      // 'All Categories' deselected - clear all selections
      this.tempSelectedItems=this.selectedCat;
      this.selectedCat = [];
    }
  }

  updateApplyButtonState() {
    if (this.applyButtonRef) {
      this.applyButtonRef.disabled = this.selectedCat.length === 0;
    }
  }

  onChangeCategory(event: any) {
    this.selectedCat = event.value;
    this.updateApplyButtonState();
    
    const selectedValues = event.value.map((item: any) => item.id);
    const subcategoryIds = selectedValues.filter((id: any) => {
      return this.allcategory.some((category: any) =>
        category.subcategories.some((sub: any) => sub.id === id)
      );
    });
    const categoryIds = selectedValues.filter((id: any) => {
      return this.allcategory.some((category: any) => category.id === id);
    });

    this.category_id = categoryIds;
    this.sub_category_id = subcategoryIds;



    this.getallprompmtByfilter(
      this.searchtext,
      this.userid,
      this.modal,
      this.category_id,
      this.sub_category_id,
      this.createdbyarray,
      this.onMyFavouriteClick,
      this.onMyPromptsClick,
      this.onMyApprovalClick,
      this.user_role,
      this.status,
      this.sort_by
    );
    this.getAllCategory(
      '',
      this.userid,
      this.modal,
      [],
      [],
      this.createdbyarray,
      this.onMyFavouriteClick,
      this.onMyPromptsClick,
      this.user_role,
      this.status
    );
  }

  openSnackbar(message: string, title: string, cssClass: string) {
    this.dialog.open(ErrorNotficationComponent, {
      data: {
        message: message,
        title: title,
        action_type: 'add',
        cssClass: cssClass,
      },
    });
  }

  private applyButtonRef: HTMLButtonElement | null = null;

  public onDropDownOpen() {
    setTimeout(() => {
      const dropdownList = document.querySelector(
        '.multiselect-dropdown .dropdown-list'
      );
      if (!dropdownList || dropdownList.querySelector('.bor-class')) return;

      const actionDiv = document.createElement('div');
      actionDiv.classList.add('bor-class'); // Apply your CSS class

      const resetBtn = document.createElement('button');
      resetBtn.innerText = 'Reset';
      resetBtn.onclick = () => this.onCategoryReset();

      const applyBtn = document.createElement('button');
      applyBtn.innerText = 'Apply';
      applyBtn.onclick = () => {
      this.onCategoryApply(this.selectedCat); 
      const toggleBtn = document.querySelector('.multiselect-dropdown .dropdown-btn');
      if (toggleBtn) {
        (toggleBtn as HTMLElement).click();
      }
      };
      resetBtn.classList.add('btn-class');
      applyBtn.classList.add('apply');

      // Store reference to apply button for later updates
      this.applyButtonRef = applyBtn;

      actionDiv.appendChild(resetBtn);
      actionDiv.appendChild(applyBtn);

      dropdownList.appendChild(actionDiv);
    }, 100);
  }

  // public save() {
 
 
  //   this.getShanshotDetails(this.category_id, this.sub_category_id);
  // }
  // public resetForm() {
  
  //   this.category_id = [];
  //   this.sub_category_id = [];
  //   this.selectedCat = [];
  //   this.clearfilter = true;
  //   this.cd.markForCheck();
  //   this.getShanshotDetails(this.category_id, this.sub_category_id);
  // }

  onCategoryApply(selectedItems: any[]) {
    this.tempSelectedItems=this.selectedCat;
   
    this.getShanshotDetails(this.category_id, this.sub_category_id);
    this.callMultipleApi();

  }

  onCategoryReset() {
 
    this.tempSelectedItems=this.selectedCat;
    this.selectedCat = [];
    this.updateApplyButtonState();
    this.category_id = [];
    this.sub_category_id = [];

  }
  


  getMostUsedPrompts(categories: any, subcategories: any) {
    this.isLoading = true;
    const params: any = {
      end_date: this.endDate ?? '',
      // search_text: '',
      limit: 5,
      offset: 0,
      sort_order: 'desc',
      count: false,
    };
    if (params.end_date == '') {
      delete params.end_date
    }
    const payload: any = {
      categories,
      subcategories,
    };
    this.gamificationService
      .getMostUsedPrompts(params, payload)
      .subscribe({
        next: (resp:any) => {
        this.isLoading = false;
       
        this.mostUsedPromptsData = resp?.data?.data;
        this.dataSource = JSON.parse(JSON.stringify(this.mostUsedPromptsData));
      },error: (error:any) => {
        this.isLoading = false;
        this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
      }
  });
  }

  getMostTrendingPrompts(categories: any, subcategories: any) {
    this.isLoading = true;
    const params: any = {
      start_date: this.startDate ?? '',
      end_date: this.endDate ?? '',
      // search_text: '',
      limit: 5,
      offset: 0,
      sort_order: 'desc',
      count: false,
    };
    if (params.start_date == '') {
      delete params.start_date;
    }
    if (params.end_date == '') {
      delete params.end_date;
    }
    const payload: any = {
      categories,
      subcategories,
    };
    this.gamificationService
      .getMostTrendingPrompts(params, payload)
      .subscribe({
        next: (resp:any) => {
        this.isLoading = false;
       
        this.mostTrendingPromptsData = resp?.data?.data;
        this.trendingPromptsDataSource = JSON.parse(
          JSON.stringify(this.mostTrendingPromptsData)
        );
      },error: (error:any) => {
        this.isLoading = false;
        this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
      }
  });
  }

  getCuratorList(categories: any, subcategories: any) {
    this.isLoading = true;
    const params: any = {
      start_date: this.startDate ?? '',
      end_date: this.endDate ?? '',
      // search_text: '',
      limit: 5,
      offset: 0,
      sort_order: 'desc',
    };
    if (params.start_date == '') {
      delete params.start_date;
    }
    if (params.end_date == '') {
      delete params.end_date;
    }
    const payload: any = {
      categories,
      subcategories,
    };
    this.gamificationService
      .getCuratorList(params, payload)
      .subscribe({
        next: (resp:any) => {
        this.isLoading = false;
       
        this.curatorListData = resp?.data?.data;
        this.curatorListDataSource = JSON.parse(
          JSON.stringify(this.curatorListData)
        );
      },error: (error:any) => {
        this.isLoading = false;
        this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
      }
  });
  }

  getPowerUsers(categories: any, subcategories: any) {
    this.isLoading = true;
    const params: any = {
      start_date: this.startDate ?? '',
      end_date: this.endDate ?? '',
      // search_text: '',
      limit: 5,
      offset: 0,
      sort_order: 'desc',
    };
    if (params.start_date == '') {
      delete params.start_date;
    }
    if (params.end_date == '') {
      delete params.end_date;
    }
    const payload: any = {
      categories,
      subcategories,
    };
    this.gamificationService
      .getPowerUsers(params, payload)
      .subscribe({
        next: (resp:any) => {
        this.isLoading = false;
        this.powerUsersData = resp?.data?.data;
        this.powerUsersDataSource = this.powerUsersData.map((item:any) => ({
          ...item,
          parsedActivity: this.parsePromptActivity(item.prompt_activity)
        }));
      },error: (error:any) => {
        this.isLoading = false;
        this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
      }
  });
  }

  viewAllMostUsedPrompts(event: MouseEvent) {  
  (event.target as HTMLButtonElement).blur();
    let payloadData = {
      categories: this.category_id, 
      subcategories : this.sub_category_id,
      end_date: this.endDate
    }
    let dialogRef= this.dialog.open(MostUsedPromptsDialogComponent, {
      data: payloadData,
      height: '100vh',
      maxWidth: '778px',
      width: '100%',
      position: { right: '0' },
      panelClass: 'custom-dialog-container',
      disableClose: true
    })

    dialogRef.afterClosed().subscribe(() => {
      const button = document.querySelector('.button-mostUsed') as HTMLButtonElement;
      button?.blur();
    });
  }
  viewTopCategories(event: MouseEvent) {   
  (event.target as HTMLButtonElement).blur();
    let payloadData = {
      categories: this.category_id, 
      subcategories : this.sub_category_id,
      start_date: this.startDate,
      end_date: this.endDate
    }
    let dialogRef = this.dialog.open(TopMostCategoriesComponent, {
      data: payloadData,
      height: '100vh',
      maxWidth: '778px',
      width: '100%',
      position: { right: '0' },
      panelClass: 'custom-dialog-container',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(() => {
      const button = document.querySelector('.button-topCategories') as HTMLButtonElement;
      button?.blur();
    });
  }

  viewAllTrendingPrompts(event: MouseEvent) {   
  (event.target as HTMLButtonElement).blur();
    let payloadData = {
      categories: this.category_id, 
      subcategories : this.sub_category_id,
      start_date: this.startDate,
      end_date: this.endDate
    }
    let dialogRef = this.dialog.open(MostTrendingPromptsDialogComponent, {
      data: payloadData,
      height: '100vh',
      maxWidth: '778px',
      width: '100%',
      position: { right: '0' },
      panelClass: 'custom-dialog-container',
      disableClose: true
    });

    dialogRef.afterClosed().subscribe(() => {
      const button = document.querySelector('.button-trending') as HTMLButtonElement;
      button?.blur();
    });
  }

  openDateSelection(){
    let payloadData = {
      categories: this.category_id, 
      subcategories : this.sub_category_id
    }
    this.dialog.open(DateRangePickerComponent, {
      data: payloadData,
      height: '25rem',
      maxWidth: '628px',
      position: { right: '20px' },
      panelClass: 'custom-dialog-container',
      disableClose: true
    })
    .afterClosed().subscribe((res: any) => {
    
      if(res !=null){
        this.value=res;
        const [startStr, endStr] = this.value.split(" - ");
        this.startDate = this.formatDate(startStr);
        this.endDate = this.formatDate(endStr);
        this.callMultipleApi();
      }
      
    })
  }

  callMultipleApi() {
    this.getTop3Users(this.category_id, this.sub_category_id);
    this.getTop3Creators(this.category_id, this.sub_category_id);
    this.getMostUsedPrompts(this.category_id, this.sub_category_id);
    this.getMostTrendingPrompts(this.category_id, this.sub_category_id);
    this.getCuratorList(this.category_id, this.sub_category_id);
    this.getPowerUsers(this.category_id, this.sub_category_id);
    this.getTopCategories();
  }

  formatDate(dateStr:any) {
    const parts = dateStr.split('/');
    const day = parts[0];
    const month = parts[1];
    const year = parts[2];
  
    const date = new Date(`${day} ${month} ${year}`);
  
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // month is 0-indexed
    const dd = String(date.getDate()).padStart(2, '0');
  
    return `${yyyy}-${mm}-${dd}`;
  }

  getTopCategories() {
    this.isLoading = true;
    const params: any = {
      start_date: this.startDate ?? '',
      end_date: this.endDate ?? '',
      search_text: '',
      limit: 5,
      offset: 0,
      sort_order: 'desc',
      count: false,
    };
    if (params.start_date == '') {
      delete params.start_date;
    }
    if (params.end_date == '') {
      delete params.end_date;
    }
  
    this.gamificationService.
    getTopCategories(params)
      .subscribe({
        next: (resp:any) => {
        this.isLoading = false;
       
        this.topCategory = resp?.data?.data;
        this.topCategories = JSON.parse(
          JSON.stringify(this.topCategory)
        );
      },error: (error:any) => {
        this.isLoading = false;
        this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
      }
  });
  }

  
  getTop3Users(categories: any, subcategories: any) {
    this.isLoading = true;
    const params: any = {
      start_date: this.startDate ?? '',
      end_date: this.endDate ?? '',
      search_text: '',
      limit: 5,
      offset: 0,
      sort_order: 'desc',
    };
    if (params.start_date == '') {
      delete params.start_date;
    }
    if (params.end_date == '') {
      delete params.end_date;
    }
    const payload: any = {
      categories,
      subcategories,
    };
    this.gamificationService
      .getTop3Users(params, payload)
      .subscribe({
        next: (resp:any) => {
        this.isLoading = false;
       
        this.topUserList = resp?.data;
        this.topUserList=this.topUserList.map((data:any, index:number) => {
          return {
            ...data
          };
        });
        this.Top_user=this.topUserList[this.currentIndex];

      },error: (error:any) => {
        this.isLoading = false;
        this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
      }
  });
  }

  
  getTop3Creators(categories: any, subcategories: any) {
    this.isLoading = true;
    const params: any = {
      start_date: this.startDate ?? '',
      end_date: this.endDate ?? '',
      search_text: '',
      limit: 5,
      offset: 0,
      sort_order: 'desc',
    };
    if (params.start_date == '') {
      delete params.start_date;
    }
    if (params.end_date == '') {
      delete params.end_date;
    }
    const payload: any = {
      categories,
      subcategories,
    };
    this.gamificationService
      .getTop3Creators(params, payload)
      .subscribe({
        next: (resp:any) => {
        this.isLoading = false;
        
        this.topCreatorList = resp?.data;
        this.topCreatorList=this.topCreatorList.map((data:any, index:number) => {
          return {
            ...data
          };
        });
        this.Top_creator=this.topCreatorList[this.current_creator_Index];
      },error: (error:any) => {
        this.isLoading = false;
        this.openSnackbar(error?.error?.message, 'An error occurred', 'error-snackbar');
      }
  });
  }

  viewAllCuratorList(event: MouseEvent) {   
  (event.target as HTMLButtonElement).blur();
    let payloadData = {
      categories: this.category_id, 
      subcategories : this.sub_category_id,
      start_date: this.startDate,
      end_date: this.endDate
    }
    let dialogRef = this.dialog.open(CuratorListDialogComponent, {
      data: payloadData,
      height: '100vh',
      maxWidth: '778px',
      width: '100%',
      position: { right: '0' },
      panelClass: 'custom-dialog-container',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(() => {
      const button = document.querySelector('.button-curratorList') as HTMLButtonElement;
      button?.blur();
    });
  }

  viewAllPowerUsers(event: MouseEvent) {   
  (event.target as HTMLButtonElement).blur();
    let payloadData = {
      categories: this.category_id, 
      subcategories : this.sub_category_id,
      start_date: this.startDate,
      end_date: this.endDate
    }
    let dialogRef = this.dialog.open(PowerUsersDialogComponent, {
      data: payloadData,
      height: '100vh',
      maxWidth: '778px',
      width: '100%',
      position: { right: '0' },
      panelClass: 'custom-dialog-container',
      disableClose: true
    });
    dialogRef.afterClosed().subscribe(() => {
      const button = document.querySelector('.button-powerUsers') as HTMLButtonElement;
      button?.blur();
    });
  }

  parsePromptActivity(activity: string): any {
    const parts = activity.split(',').map(p => {
      const [key, value] = p.trim().split(':').map(x => x.trim());
      return `${value} ${key}`;
    });
  
    return {
      first: parts[0] || '',
      second: parts[1] || '',
      rest: parts.slice(2),
    };
  }

  ngOnDestroy() {
    this.cleanupStorage();
  }
  
  private cleanupStorage() {
    if (localStorage.getItem(this.STORAGE_KEY)) {
      localStorage.removeItem(this.STORAGE_KEY);
    }
  }
}
